import { makeObservable } from "mobx";
import { BaseCategoryViewStore } from "application/categories/stores";
import { podcastCategory, userDeviceBulkContentType } from "common/constants";
import { homeContentType } from "application/common/content-access";

class ShiurimViewStore extends BaseCategoryViewStore {
    constructor(rootStore, { routeStore }) {
        super(rootStore);
        this.category = podcastCategory.shiur;
        this.contentType = userDeviceBulkContentType.shiurim;
        makeObservable(this);
        this.routeStore = routeStore;
        this.queryUtility.filter.set("category", this.category);
    }

    find(params) {
        if (this.selectedDevice) {
            params.deviceId = this.selectedDevice.id;
        }
        return this.routeStore.find(params);
    }

    search(params) {
        params.category = this.category;
        params.contentType = homeContentType.podcast;
        return this.routeStore.search(params);
    }
}

export default ShiurimViewStore;
